import { Icons } from '@commenda/kakashi';
import { DocusignSenderView } from '../DocusignSenderView';

type SenderViewStepProps = {
  senderViewUrl: string;
  onClose: () => void;
  onEvent: (event: string) => void;
};

export function SenderViewStep({
  senderViewUrl,
  onClose,
  onEvent,
}: SenderViewStepProps) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-bg-primary">
      <div className="flex items-center justify-between px-6 py-3 border-b border-border-primary">
        <div className="flex flex-col gap-0.5">
          <h2 className="txt-large-medium text-text-primary">
            Place Signature Fields
          </h2>
          <p className="txt-small-regular text-text-secondary">
            Drag and drop signature fields onto the document, then click Send.
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-md hover:bg-bg-secondary transition-colors"
        >
          <Icons.XClose className="size-5 text-fg-quaternary" />
        </button>
      </div>
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <DocusignSenderView url={senderViewUrl} onEvent={onEvent} />
      </div>
    </div>
  );
}
